angular.module('UndergroundWebApp').factory('setAttribute', ['$timeout', '$window', function ($timeout, $window) {
    return function (id, attribute, value) {
        // timeout makes sure that is invoked after any other event has been triggered.
        // e.g. click events that need to run before the focus or
        // inputs elements that are in a disabled state but are enabled when those events
        // are triggered.
        $timeout(function () {
            var element = $window.document.getElementById(id);
            if (element)
                element.setAttribute(attribute, value);
        });
    };
}]);

